import {
  DriverDay_Read_Typeahead,
  getV1CompaniesCompanyIdDriverDaysTypeahead,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  DriverDay_Read_Typeahead,
  DriverDay_Read_Typeahead,
  Record<string, unknown>
> & { companyId: string };

export default function AutocompleteDriverDaysTypeahead<T extends FieldValues>({
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteDriverDaysTypeahead"
      fetchFn={{
        arguments: { path: { 'company-id': companyId } },
        request: getV1CompaniesCompanyIdDriverDaysTypeahead,
      }}
      parseFn={(item: DriverDay_Read_Typeahead) => ({
        _entity: item,
        label: item.driver_day_id,
        value: item.driver_day_id,
      })}
    />
  );
}
